// extracted by mini-css-extract-plugin
export var imageWrap = "index-module--image-wrap--1uKjU";
export var left = "index-module--left--3qTgP";